<page-data-manager>
  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <h2>
          Plantios
        </h2>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-md-4 form-group">
      <label for="select-safra">Safra</label>
      <select
        id="select-safra"
        ng-model="plantios.filters.safra"
        ng-options="safra.descricao for safra in safras | orderBy: '-descricao' track by safra.id"
        class="form-control"
        ng-change="plantios.changeSafra()">
      </select>
    </div>

    <div class="col-xs-12 col-md-4 form-group">
      <label for="select-gleba">Talhão</label>
      <select
        id="select-gleba"
        ng-model="plantios.filters.gleba"
        ng-options="gleba.descricao for gleba in $root.currentPropriedade.glebas | orderBy: 'descricao' track by gleba.id"
        class="form-control"
        ng-change="plantios.filterPlantios()">
        <option value="">Todas</option>
      </select>
    </div>

    <div class="col-xs-12 col-md-4 form-group">
      <label for="select-atividade">Cultura</label>
      <select
        id="select-atividade"
        ng-model="plantios.filters.atividade"
        ng-options="atividade.descricao for atividade in plantios.atividades track by atividade.id"
        class="form-control"
        ng-change="plantios.filterPlantios()">
        <option value="">Todas</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 text-right form-group">
      <button
        class="btn btn-sm btn-white"
        ng-click="plantios.alterarPeriodo()"
        ng-disabled="plantios.plantiosSelecionados.length === 0"
        ng-if="$root.parametros.nao_cliente_agrogestao">
          Alterar período
      </button>
      <button class="btn btn-sm btn-white" ng-click="plantios.reprocess()">Reprocessar</button>
      <button class="btn btn-sm btn-white" ng-click="plantios.inactivatePreviousSafras()">Inativar safras anteriores</button>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12" ng-show="plantios.plantios">
      <div class="panel panel-default">
        <div class="panel-body">
          <table class="table table-hover table-striped">
            <tbody>
              <tr
                ng-repeat="plantio in plantios.plantios | orderBy: ['gleba.descricao','data_inicio']"
                ng-class="{'warning': plantio.data_encerramento}"
                ng-click="plantios.togglePlantioSelecionado(plantio.id)"
              >
                <td class="text-right vertical-middle">
                  <input
                    type="checkbox"
                    name="plantios[]"
                    ng-checked="plantios.plantiosSelecionados.includes(plantio.id)"
                  />
                </td>

                <td class="vertical-middle">
                  {{plantio.gleba.descricao}}<br>
                  <span class="text-light">Área total:</span>&nbsp;<strong>{{plantio.gleba.area_total | number:2}} ha</strong>
                </td>

                <td class="vertical-middle">
                  <div class="checkbox">
                    {{plantio.atividade.descricao | capitalize}}
                    (<span ng-show="plantio.area !== plantio.area_ativa"><small class="text-light line-through" >{{plantio.area | number:2}}</small>&nbsp;</span>{{plantio.area_ativa | number:2}} ha)
                    <br>
                    <span class="text-light">Cultivar:</span>&nbsp;<strong>{{plantio.insumo.descricao}}</strong><br>
                    <span class="text-light">Origem: {{plantio.origem}}</span><br>
                    <span class="text-light">Período: {{plantio.periodo.descricao}}</span>
                  </div>
                </td>

                <td class="vertical-middle">
                  <div class="checkbox">
                    {{plantio.data_inicio | date}}<br>
                    <span class="text-light" ng-show="plantio.data_encerramento">Encerramento:</span>&nbsp;<strong>{{plantio.data_encerramento | date}}</strong>
                  </div>
                </td>

                <td class="text-right vertical-middle" ng-if="!plantio.data_encerramento">
                  <button class="btn btn-sm btn-white" ng-click="plantios.inactivate($event, plantio)">Inativar</button>
                </td>


                <td class="text-right vertical-middle" ng-if="plantio.data_encerramento">
                  <button class="btn btn-sm btn-white" ng-click="plantios.reactivate($event, plantio)">Reativar</button><br>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</page-data-manager>
